import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearDSRMonthWiseReportDetails,
  clearDSRMonthWiseReportList,
  setDSRMonthWiseReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import { getAllDSRMonthWiseReport } from "../services/reports.services";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
// import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import FormDatePicker from "../../../components/formFields/FormDateField";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { getAllSalesRepresentative } from "../../salesrepresentativeassign/services/salesRepresentative.services";
import { ISalesRepresentative } from "../../salesrepresentativeassign/salesRepresentativeModel";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { sumBy } from "lodash";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  useEffect(() => {
    formRenderProps.onChange("abcd", { value: "forenable" });
  }, []);

  return null;
};

const DSRMonthWiseReportForm: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const DSRMonthWiseReportDetails = useAppSelector(
    (state) => state.reports.DSRMonthWiseReportDetails
  );
  const DSRMonthWiseReportList = useAppSelector(
    (state) => state.reports.DSRMonthWiseReportList
  );
  const SalesRepresentativeList = useAppSelector(
    (state) => state.salesrepresentative.SalesRepresentativeList
  );
  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  useEffect(() => {
    dispatch(getAllSalesRepresentative());
    return () => {
      dispatch(clearDSRMonthWiseReportDetails());
      dispatch(clearDSRMonthWiseReportList());

      //   dispatch(setCurrentPage(0));
    };
  }, []);
  const handleSubmit = async (values: any) => {
    const payload = {
      sr_id: values?.sr_id ? values?.sr_id : null,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : "",
      limit: 10,
      skip: 0,
    };
    dispatch(
      setDSRMonthWiseReport({
        sr_id: values?.sr_id ? values?.sr_id : null,
        from_date: values?.from_date,
        to_date: values?.to_date,
      })
    );
    await dispatch(getAllDSRMonthWiseReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={DSRMonthWiseReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      SR Monthly Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ width: "100%" }}>
                    <Field
                      name="sr_id"
                      label={"Sales Representative"}
                      placeholder="Select Sales Representative"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={SalesRepresentativeList?.map(
                        (expensetype: ISalesRepresentative) => {
                          return {
                            value: expensetype?.id,
                            label: `${expensetype?.first_name} ${expensetype?.middle_name} ${expensetype?.last_name}`,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="From Date"
                      format={"dd/MM/yyyy"}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="To Date"
                      format={"dd/MM/yyyy"}
                      minDate={
                        formRenderProps.valueGetter("from_date") ||
                        new Date(1900, 1, 1)
                      }
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <div style={{ marginTop: "35px" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : (
          DSRMonthWiseReportList &&
          DSRMonthWiseReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10, minHeight: "30vh" }}>
              <DSRMonthWiseExportTable />
            </ShadowCard>
          )
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const DSRMonthWiseExportTable: React.FC = () => {
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  const DSRMonthWiseReportList = useAppSelector(
    (state) => state.reports.DSRMonthWiseReportList
  );
  const DSRMonthWiseReportDetails = useAppSelector(
    (state) => state.reports.DSRMonthWiseReportDetails
  );

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const handlePrint = (props: any, type: string) => {
    const state = {
      sr_id: props?.sr_id ? props?.sr_id : null,
      from_date: props?.from_date
        ? moment(props?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: props?.to_date
        ? moment(props?.to_date).format("YYYY-MM-DD")
        : "",
      initialValues: props.initialValues,
    };
    if (type === "dsrmonthwisereport") {
      sessionStorage.setItem("dsrmonthwisereportState", JSON.stringify(state));
      const reportTab = window.open("/dsrmonthwisereportprint", "_blank");
      const interval = setInterval(() => {
        if (reportTab?.closed) {
          sessionStorage.removeItem("dsrmonthwisereportState");
          clearInterval(interval);
        }
      }, 1000);
    }
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".employee-details-report-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(
      `${DSRMonthWiseReportList?.[0].sr_name}`
    );
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffabab" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        if (rowIndex === rows.length - 1) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9E1F2" },
          };
        }
        if (excelCell.value === "Sunday") {
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "ffff00",
            },
          };
        }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;

          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `SR Monthly Report Of ${
          DSRMonthWiseReportList?.[0].sr_name
        }-${moment().format("DD-MM-YYYY hh:mm A")}.xlsx`
      );
    });
  };

  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const initialValues = {
    filter_columns: [
      "sr_name",
      "month",
      "plan_date",
      "day",
      "working_day",
      "holiday",
      "distributor_name",
      "area_name",
      "total_call",
      "prod_call",
      "prod_call_percentage",
      "da_local",
      "da_up_nh",
      "other_expense",
      "total_expense",
      "CTCC_amount",
      "CTCC_B_amount",
      "pm_amount",
      "pm_b_amount",
      "pickle",
      "hing",
      "instant",
      "flour",
      "papad_mathiya",
      "other_l",
      "sale_in_amount",
      "sale_in_kg",
      "sales_percentage",
    ],
  };
  const columns = [
    { label: "SR Name", value: "sr_name" },
    { label: "Month", value: "month" },
    { label: "Plan Date", value: "plan_date" },
    { label: "Day", value: "day" },
    { label: "Working Day", value: "working_day" },
    { label: "Holiday", value: "holiday" },
    { label: "Distributor Name", value: "distributor_name" },
    { label: "Area Name", value: "area_name" },
    { label: "Total Call", value: "total_call" },
    { label: "Production Call", value: "prod_call" },
    { label: "Percentage(%)", value: "prod_call_percentage" },

    { label: "DA Local", value: "da_local" },
    { label: "DA-UP/ NH", value: "da_up_nh" },
    { label: "Other Expense", value: "other_expense" },
    { label: "Total Expense", value: "total_expense" },
    { label: "CTCC", value: "CTCC_amount" },
    { label: "CTCC-B", value: "CTCC_B_amount" },
    { label: "PM", value: "pm_amount" },
    { label: "PM-B", value: "pm_b_amount" },
    { label: "Pickle", value: "pickle" },
    { label: "Hing", value: "hing" },
    { label: "Instant", value: "instant" },
    { label: "Flour", value: "flour" },
    { label: "Papad Mathiya", value: "papad_mathiya" },
    { label: "Other-L", value: "other_l" },
    { label: "Sale in Amount", value: "sale_in_amount" },
    { label: "Sale in KG", value: "sale_in_kg" },
    { label: "Sales Percentage", value: "sales_percentage" },
  ];

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {DSRMonthWiseReportList && DSRMonthWiseReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      SR Monthly Report
                      <>
                        <p
                          style={{
                            fontSize: 16,
                            lineHeight: "24px",
                            margin: 0,
                          }}
                        >
                          For Period :-{" "}
                          {DSRMonthWiseReportDetails.from_date &&
                            DSRMonthWiseReportDetails.to_date &&
                            `( ${moment(
                              DSRMonthWiseReportDetails.from_date
                            ).format("DD/MM/YYYY")} - ${moment(
                              DSRMonthWiseReportDetails.to_date
                            ).format("DD/MM/YYYY")} )`}{" "}
                        </p>
                      </>
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            handlePrint(
                              {
                                ...DSRMonthWiseReportDetails,
                                initialValues: {
                                  filter_columns:
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ),
                                },
                              },
                              "dsrmonthwisereport"
                            )
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 10 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 1,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 340px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  employee-details-report-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                            position: "sticky",
                            top: 0,
                          }}
                        >
                          <th style={{ minWidth: 50 }}>SR. No</th>
                          {checkInclude("sr_name", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>
                              Sales Representaive
                            </th>
                          )}
                          {checkInclude("month", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>Month</th>
                          )}
                          {checkInclude("plan_date", formRenderProps) && (
                            <th style={{ minWidth: 110 }}>Plan Date</th>
                          )}
                          {checkInclude("day", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>Day</th>
                          )}
                          {checkInclude("working_day", formRenderProps) && (
                            <th style={{ minWidth: 20 }}>Working Day</th>
                          )}
                          {checkInclude("holiday", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>Holiday</th>
                          )}
                          {checkInclude(
                            "distributor_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 150 }}>Distributor Name</th>
                          )}
                          {checkInclude("area_name", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Town</th>
                          )}
                          {checkInclude("total_call", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>TC</th>
                          )}
                          {checkInclude("prod_call", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>PC</th>
                          )}
                          {checkInclude(
                            "prod_call_percentage",
                            formRenderProps
                          ) && <th style={{ minWidth: 50 }}>(%)</th>}
                          {checkInclude("da_local", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>DA-Local</th>
                          )}
                          {checkInclude("da_up_nh", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>DA-UP / NH</th>
                          )}
                          {checkInclude("other_expense", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Other Expense</th>
                          )}
                          {checkInclude("total_expense", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Total Expense</th>
                          )}
                          {checkInclude("CTCC_amount", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>CTCC</th>
                          )}
                          {checkInclude("CTCC_B_amount", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>CTCC-B</th>
                          )}
                          {checkInclude("pm_amount", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>PM</th>
                          )}
                          {checkInclude("pm_b_amount", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>PM-B</th>
                          )}
                          {checkInclude("pickle", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Pickle</th>
                          )}
                          {checkInclude("hing", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Hing</th>
                          )}
                          {checkInclude("instant", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Instant</th>
                          )}
                          {checkInclude("flour", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Flour</th>
                          )}
                          {checkInclude("papad_mathiya", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Papad Mathiya</th>
                          )}
                          {checkInclude("other_l", formRenderProps) && (
                            <th style={{ minWidth: 120 }}>Other-L</th>
                          )}
                          {checkInclude("sale_in_amount", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Sales in Amount</th>
                          )}
                          {checkInclude("sale_in_kg", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Sales in KG</th>
                          )}
                          {checkInclude(
                            "sales_percentage",
                            formRenderProps
                          ) && <th style={{ minWidth: 150 }}>Sales (%)</th>}
                        </tr>
                      </thead>
                      {/* Table Body */}
                      <tbody>
                        {DSRMonthWiseReportList.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                <td>{rowIndex + 1}</td>
                                {checkInclude("sr_name", formRenderProps) && (
                                  <td>{item?.sr_name}</td>
                                )}
                                {checkInclude("month", formRenderProps) && (
                                  <td>{item?.month}</td>
                                )}
                                {checkInclude("plan_date", formRenderProps) && (
                                  <td>{item?.plan_date}</td>
                                )}
                                {checkInclude("day", formRenderProps) && (
                                  <td>{item?.day}</td>
                                )}

                                {checkInclude(
                                  "working_day",
                                  formRenderProps
                                ) && <td>{item?.working_day}</td>}
                                {checkInclude("holiday", formRenderProps) && (
                                  <td>{item?.holiday}</td>
                                )}
                                {checkInclude(
                                  "distributor_name",
                                  formRenderProps
                                ) && <td>{item?.distributor_name}</td>}
                                {checkInclude("area_name", formRenderProps) && (
                                  <td>{item?.area_name}</td>
                                )}
                                {checkInclude(
                                  "total_call",
                                  formRenderProps
                                ) && (
                                  <td className="text-center">
                                    {item?.total_call}
                                  </td>
                                )}
                                {checkInclude("prod_call", formRenderProps) && (
                                  <td className="text-center">
                                    {item?.prod_call}
                                  </td>
                                )}
                                {checkInclude(
                                  "prod_call_percentage",
                                  formRenderProps
                                ) && (
                                  <td className="text-center">
                                    {item?.prod_call_percentage}
                                  </td>
                                )}
                                {checkInclude("da_local", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.da_local)}
                                  </td>
                                )}
                                {checkInclude("da_up_nh", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.da_up_nh)}
                                  </td>
                                )}
                                {checkInclude(
                                  "other_expense",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.other_expense)}
                                  </td>
                                )}
                                {checkInclude(
                                  "total_expense",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.total_expense)}
                                  </td>
                                )}
                                {checkInclude(
                                  "CTCC_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.CTCC_amount)}
                                  </td>
                                )}
                                {checkInclude(
                                  "CTCC_B_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.CTCC_B_amount)}
                                  </td>
                                )}
                                {checkInclude("pm_amount", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.pm_amount)}
                                  </td>
                                )}
                                {checkInclude(
                                  "pm_b_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.pm_b_amount)}
                                  </td>
                                )}
                                {checkInclude("pickle", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.pickle)}
                                  </td>
                                )}
                                {checkInclude("hing", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.hing)}
                                  </td>
                                )}
                                {checkInclude("instant", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.instant)}
                                  </td>
                                )}
                                {checkInclude("flour", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.flour)}
                                  </td>
                                )}
                                {checkInclude(
                                  "papad_mathiya",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.papad_mathiya)}
                                  </td>
                                )}
                                {checkInclude("other_l", formRenderProps) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.other_l)}
                                  </td>
                                )}
                                {checkInclude(
                                  "sale_in_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.sale_in_amount)}
                                  </td>
                                )}
                                {checkInclude(
                                  "sale_in_kg",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {item?.sale_in_kg?.toFixed(2)}
                                  </td>
                                )}
                                {checkInclude(
                                  "sales_percentage",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {item?.sales_percentage}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>TOTAL</td>
                          {checkInclude("sr_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("month", formRenderProps) && <td></td>}
                          {checkInclude("plan_date", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("day", formRenderProps) && <td></td>}

                          {checkInclude("working_day", formRenderProps) && (
                            <td className="text-center">
                              {sumBy(DSRMonthWiseReportList, "working_day")}
                            </td>
                          )}
                          {checkInclude("holiday", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude(
                            "distributor_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude("area_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("total_call", formRenderProps) && (
                            <td className="text-center">
                              {sumBy(DSRMonthWiseReportList, "total_call")}
                            </td>
                          )}
                          {checkInclude("prod_call", formRenderProps) && (
                            <td className="text-center">
                              {sumBy(DSRMonthWiseReportList, "prod_call")}
                            </td>
                          )}
                          {checkInclude(
                            "prod_call_percentage",
                            formRenderProps
                          ) && <td className="text-center">0</td>}
                          {checkInclude("da_local", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "da_local")
                              )}
                            </td>
                          )}
                          {checkInclude("da_up_nh", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "da_up_nh")
                              )}
                            </td>
                          )}
                          {checkInclude("other_expense", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "other_expense")
                              )}
                            </td>
                          )}
                          {checkInclude("total_expense", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "total_expense")
                              )}
                            </td>
                          )}
                          {checkInclude("CTCC_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "CTCC_amount")
                              )}
                            </td>
                          )}
                          {checkInclude("CTCC_B_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "CTCC_B_amount")
                              )}
                            </td>
                          )}
                          {checkInclude("pm_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "pm_amount")
                              )}
                            </td>
                          )}
                          {checkInclude("pm_b_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "pm_b_amount")
                              )}
                            </td>
                          )}
                          {checkInclude("pickle", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "pickle")
                              )}
                            </td>
                          )}
                          {checkInclude("hing", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "hing")
                              )}
                            </td>
                          )}
                          {checkInclude("instant", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "instant")
                              )}
                            </td>
                          )}
                          {checkInclude("flour", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "flour")
                              )}
                            </td>
                          )}
                          {checkInclude("papad_mathiya", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "papad_mathiya")
                              )}
                            </td>
                          )}
                          {checkInclude("other_l", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "other_l")
                              )}
                            </td>
                          )}
                          {checkInclude("sale_in_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(DSRMonthWiseReportList, "sale_in_amount")
                              )}
                            </td>
                          )}
                          {checkInclude("sale_in_kg", formRenderProps) && (
                            <td className="text-end">
                              {sumBy(
                                DSRMonthWiseReportList,
                                "sale_in_kg"
                              )?.toFixed(2)}
                            </td>
                          )}
                          {checkInclude(
                            "sales_percentage",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {/* {sumBy(
                                DSRMonthWiseReportList,
                                "sales_percentage"
                              )} */}
                              0
                            </td>
                          )}
                        </tr>
                      </tfoot>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default DSRMonthWiseReportForm;
